import { useEffect, useContext, useRef, useCallback, useState } from "react";
import { createMarkerContent, loadScript, map_settings } from "../../../map";
import { Context } from "../Provider";
import { formatTimestampInMap } from "../../../utils";

const FtmMap = () => {
    const mapRef = useRef(null);
    const mapInstance = useRef(null);
    const boundsRef = useRef(null);
    const [mapLoaded, setMapLoaded] = useState(false);

    const { state } = useContext(Context);
    const { ftm } = state;
    const { ftm_forename, ftm_surname, ftm_latitude, ftm_longitude, ftm_last_location_update_timestamp } = ftm;

    // Load the Google Maps script
    useEffect(() => {
        loadScript(
            map_settings.map_script_url,
            () => setMapLoaded(true),
            () => console.error("Failed to load Google Maps script.")
        );
    }, []);

    // Initialize the map
    const initializeMap = useCallback(() => {
        if (mapInstance.current || !window.google?.maps) return;

        mapInstance.current = new window.google.maps.Map(mapRef.current, {
            center: { lat: parseFloat(ftm_latitude), lng: parseFloat(ftm_longitude) },
            zoom: 8,
            mapId: "FTM_MAP",
        });

        boundsRef.current = new window.google.maps.LatLngBounds();
    }, [ftm_latitude, ftm_longitude]);

    // Add marker with InfoWindow
    const addMarkers = useCallback(() => {
        if (!ftm_latitude || !ftm_longitude || !window.google?.maps) return;

        const location = {
            lat: parseFloat(ftm_latitude),
            lng: parseFloat(ftm_longitude),
        };

        // Create InfoWindow content (HTML allowed)
        const infoWindow = new window.google.maps.InfoWindow({
            content: `
                <div style="font-size:14px;">
                    <strong>${ftm_forename} ${ftm_surname}</strong><br/>
                    Latitude: ${ftm_latitude}<br/>
                    Longitude: ${ftm_longitude}<br/>
                    Last update: ${formatTimestampInMap(ftm_last_location_update_timestamp)}
                </div>
            `,
            disableAutoPan: true,     // optional: stops map from panning
            closeBox: false
        });

        // Create marker
        const marker = new window.google.maps.marker.AdvancedMarkerElement({
            position: location,
            content: createMarkerContent(map_settings.ftm_map_icon),
            map: mapInstance.current,
            title: `${ftm_forename} ${ftm_surname}`,
        });

        // Open InfoWindow on marker click
        marker.addListener("click", () => {
            infoWindow.open({
                anchor: marker,
                map: mapInstance.current,
            });
        });

        mapInstance.current.setZoom(8);
    }, [ftm_forename, ftm_latitude, ftm_longitude, ftm_surname]);

    // Initialize and add markers when map is ready
    useEffect(() => {
        if (mapLoaded) {
            initializeMap();
            addMarkers();
        }
    }, [mapLoaded, initializeMap, addMarkers]);

    return (
        <div className="page-header min-height-300 border-radius-xl ">
            <div ref={mapRef} style={{ width: "100%", height: 350 }} />
        </div>
    );
};

export default FtmMap;